if (!customElements.get('tabbed-content')) {
  class TabbedContent extends HTMLElement {
    constructor () {
      super()
      this.tabsParent = this.querySelector('.tabbed-content__tabs')
      this.panels = this.querySelectorAll('.tabbed-content__panel')
      this.handleTabClick = this.handleTabClick.bind(this)
      this.handleTabKeydown = this.handleTabKeydown.bind(this)
    }

    connectedCallback () {
      this.tabsParent.addEventListener('click', this.handleTabClick)
      this.tabsParent.addEventListener('keydown', this.handleTabKeydown)
    }

    disconnectedCallback () {
      this.tabsParent.removeEventListener('click', this.handleTabClick)
      this.tabsParent.removeEventListener('keydown', this.handleTabKeydown)
    }

    handleTabClick (event) {
      const tab = event.target.closest('.tabbed-content__tab')
      if (!tab || !this.tabsParent.contains(tab)) return
      this.activateTab(tab)
    }

    handleTabKeydown (event) {
      const tabs = Array.from(this.tabsParent.querySelectorAll('.tabbed-content__tab'))
      const currentTab = event.target.closest('.tabbed-content__tab')
      if (!currentTab) return
      const currentIndex = tabs.indexOf(currentTab)
      let newIndex = currentIndex

      switch (event.key) {
        case 'ArrowLeft':
          newIndex = (currentIndex - 1 + tabs.length) % tabs.length
          break
        case 'ArrowRight':
          newIndex = (currentIndex + 1) % tabs.length
          break
        case 'Home':
          newIndex = 0
          break
        case 'End':
          newIndex = tabs.length - 1
          break
        default:
          return
      }

      event.preventDefault()
      const newTab = tabs[newIndex]
      if (newTab) {
        this.activateTab(newTab)
        newTab.focus()
      }
    }

    activateTab (tab) {
      const panelId = tab.getAttribute('aria-controls')
      const panel = document.getElementById(panelId)
      if (!panel) return

      // Handle Tabs
      this.tabsParent.querySelectorAll('.tabbed-content__tab').forEach(t => {
        t.setAttribute('aria-selected', 'false')
        t.setAttribute('tabindex', '-1')
      })
      tab.setAttribute('aria-selected', 'true')
      tab.setAttribute('tabindex', '0')

      // Handle Panels
      this.panels.forEach(p => p.classList.remove('active'))
      panel.classList.add('active')
    }
  }

  customElements.define('tabbed-content', TabbedContent)
}